import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section id="garantia" className="py-10 md:py-20 px-4 bg-navy-dark text-cream-bg" data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex justify-center" data-id="element-159">
            <div className="relative" data-id="element-160">
              <div className="w-32 h-32 md:w-48 md:h-48 rounded-full bg-gold flex items-center justify-center" data-id="element-161">
                <div className="text-center" data-id="element-162">
                  <div className="font-serif text-4xl md:text-6xl font-bold text-navy-dark" data-id="element-163">
                    7
                  </div>
                  <div className="font-bold text-navy-dark text-sm md:text-base" data-id="element-164">
                    DÍAS
                  </div>
                </div>
              </div>
              <Shield className="absolute -bottom-2 -right-2 md:-bottom-4 md:-right-4 w-12 h-12 md:w-20 md:h-20 text-gold" data-id="element-165" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-center md:text-left" data-id="element-166">
            <h2 className="font-serif text-2xl md:text-4xl font-bold mb-2 md:mb-4" data-id="element-167">
              GARANTÍA TOTAL
            </h2>
            <h3 className="text-lg md:text-xl font-bold text-gold mb-3 md:mb-4" data-id="element-168">
              7 días para probarlo o te devolvemos el 100%
            </h3>
            <p className="text-cream-bg/90 mb-3 md:mb-4 leading-relaxed text-sm md:text-base" data-id="element-169">
              Abrís los volúmenes, usás las fichas en tu próximo encuentro,
              probás el banco de preguntas. Si no es lo que esperabas: sin
              preguntas, sin formularios, sin drama.
            </p>
            <p className="text-xs md:text-sm text-cream-bg/70" data-id="element-170">
              (Tasa de devoluciones menor al 1%)
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}